import { render, staticRenderFns } from "./MyContainerDeliveryOrderListItem.vue?vue&type=template&id=6978d0a8&scoped=true&"
import script from "./MyContainerDeliveryOrderListItem.vue?vue&type=script&lang=js&"
export * from "./MyContainerDeliveryOrderListItem.vue?vue&type=script&lang=js&"
import style0 from "./MyContainerDeliveryOrderListItem.vue?vue&type=style&index=0&id=6978d0a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6978d0a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/data/jenkins/workspace/booking-fe-stg/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6978d0a8')) {
      api.createRecord('6978d0a8', component.options)
    } else {
      api.reload('6978d0a8', component.options)
    }
    module.hot.accept("./MyContainerDeliveryOrderListItem.vue?vue&type=template&id=6978d0a8&scoped=true&", function () {
      api.rerender('6978d0a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/App/VSL/MyContainerDeliveryOrder/MyContainerDeliveryOrderListItem.vue"
export default component.exports